import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function stringRequired(t: TranslateFn): z.ZodString {
    return z.string().min(1, t('validation.required'));
}
